// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1529":"a700114f","4749":"e6e2187d"}[chunkId] + ".chunk.css";
};